/**
 * @fileoverview gRPC-Web generated client stub for stronachgroup.first.racehorse360
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.4.1
// 	protoc              v0.0.0
// source: stronachgroup/first/racehorse360/user_service.proto

/* eslint-disable */
// @ts-nocheck

const grpc = {};
grpc.web = require("grpc-web");

var google_api_annotations_pb = require("../../../google/api/annotations_pb.js");

var google_api_visibility_pb = require("../../../google/api/visibility_pb.js");

var protoc$gen$openapiv2_options_annotations_pb = require("../../../protoc-gen-openapiv2/options/annotations_pb.js");

var stronachgroup_first_racehorse360_messages_pb = require("../../../stronachgroup/first/racehorse360/messages_pb.js");
const proto = {};
proto.stronachgroup = {};
proto.stronachgroup.first = {};
proto.stronachgroup.first.racehorse360 = require("./user_service_pb.js");

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.stronachgroup.first.racehorse360.UserServiceClient =
  function UserServiceClient(hostname, credentials, options) {
    if (!options) options = {};
    options.format = "text";

    /**
     * @private @const {!grpc.web.GrpcWebClientBase} The client
     */
    this.client_ = new grpc.web.GrpcWebClientBase(options);

    /**
     * @private @const {string} The hostname
     */
    this.hostname_ = hostname.replace(/\/+$/, "");
  };

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.stronachgroup.first.racehorse360.UserServicePromiseClient =
  function UserServicePromiseClient(hostname, credentials, options) {
    if (!options) options = {};
    options.format = "text";

    /**
     * @private @const {!grpc.web.GrpcWebClientBase} The client
     */
    this.client_ = new grpc.web.GrpcWebClientBase(options);

    /**
     * @private @const {string} The hostname
     */
    this.hostname_ = hostname.replace(/\/+$/, "");
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.FindOrCreateUserRequest,
 *   !proto.stronachgroup.first.racehorse360.AuthUser>}
 */
const methodDescriptor_UserService_FindOrCreateUser =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.UserService/FindOrCreateUser",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.FindOrCreateUserRequest,
    stronachgroup_first_racehorse360_messages_pb.AuthUser,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.FindOrCreateUserRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.AuthUser.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.FindOrCreateUserRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.AuthUser)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.AuthUser>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.UserServiceClient.prototype.findOrCreateUser =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.UserService/FindOrCreateUser",
      request,
      metadata || {},
      methodDescriptor_UserService_FindOrCreateUser,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.FindOrCreateUserRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.AuthUser>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.UserServicePromiseClient.prototype.findOrCreateUser =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.UserService/FindOrCreateUser",
      request,
      metadata || {},
      methodDescriptor_UserService_FindOrCreateUser
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.GrantDeveloperAccessRequest,
 *   !proto.stronachgroup.first.racehorse360.User>}
 */
const methodDescriptor_UserService_GrantDeveloperAccess =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.UserService/GrantDeveloperAccess",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.GrantDeveloperAccessRequest,
    stronachgroup_first_racehorse360_messages_pb.User,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.GrantDeveloperAccessRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.User.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.GrantDeveloperAccessRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.User)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.User>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.UserServiceClient.prototype.grantDeveloperAccess =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.UserService/GrantDeveloperAccess",
      request,
      metadata || {},
      methodDescriptor_UserService_GrantDeveloperAccess,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.GrantDeveloperAccessRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.User>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.UserServicePromiseClient.prototype.grantDeveloperAccess =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.UserService/GrantDeveloperAccess",
      request,
      metadata || {},
      methodDescriptor_UserService_GrantDeveloperAccess
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.AssignRoleRequest,
 *   !proto.stronachgroup.first.racehorse360.User>}
 */
const methodDescriptor_UserService_AssignRole = new grpc.web.MethodDescriptor(
  "/stronachgroup.first.racehorse360.UserService/AssignRole",
  grpc.web.MethodType.UNARY,
  stronachgroup_first_racehorse360_messages_pb.AssignRoleRequest,
  stronachgroup_first_racehorse360_messages_pb.User,
  /**
   * @param {!proto.stronachgroup.first.racehorse360.AssignRoleRequest} request
   * @return {!Uint8Array}
   */
  function (request) {
    return request.constructor.encode(request).finish();
  },
  stronachgroup_first_racehorse360_messages_pb.User.decode
);

/**
 * @param {!proto.stronachgroup.first.racehorse360.AssignRoleRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.User)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.User>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.UserServiceClient.prototype.assignRole =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.UserService/AssignRole",
      request,
      metadata || {},
      methodDescriptor_UserService_AssignRole,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.AssignRoleRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.User>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.UserServicePromiseClient.prototype.assignRole =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.UserService/AssignRole",
      request,
      metadata || {},
      methodDescriptor_UserService_AssignRole
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.RemoveRoleRequest,
 *   !proto.stronachgroup.first.racehorse360.User>}
 */
const methodDescriptor_UserService_RemoveRole = new grpc.web.MethodDescriptor(
  "/stronachgroup.first.racehorse360.UserService/RemoveRole",
  grpc.web.MethodType.UNARY,
  stronachgroup_first_racehorse360_messages_pb.RemoveRoleRequest,
  stronachgroup_first_racehorse360_messages_pb.User,
  /**
   * @param {!proto.stronachgroup.first.racehorse360.RemoveRoleRequest} request
   * @return {!Uint8Array}
   */
  function (request) {
    return request.constructor.encode(request).finish();
  },
  stronachgroup_first_racehorse360_messages_pb.User.decode
);

/**
 * @param {!proto.stronachgroup.first.racehorse360.RemoveRoleRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.User)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.User>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.UserServiceClient.prototype.removeRole =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.UserService/RemoveRole",
      request,
      metadata || {},
      methodDescriptor_UserService_RemoveRole,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.RemoveRoleRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.User>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.UserServicePromiseClient.prototype.removeRole =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.UserService/RemoveRole",
      request,
      metadata || {},
      methodDescriptor_UserService_RemoveRole
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.GetUserRequest,
 *   !proto.stronachgroup.first.racehorse360.User>}
 */
const methodDescriptor_UserService_GetUser = new grpc.web.MethodDescriptor(
  "/stronachgroup.first.racehorse360.UserService/GetUser",
  grpc.web.MethodType.UNARY,
  stronachgroup_first_racehorse360_messages_pb.GetUserRequest,
  stronachgroup_first_racehorse360_messages_pb.User,
  /**
   * @param {!proto.stronachgroup.first.racehorse360.GetUserRequest} request
   * @return {!Uint8Array}
   */
  function (request) {
    return request.constructor.encode(request).finish();
  },
  stronachgroup_first_racehorse360_messages_pb.User.decode
);

/**
 * @param {!proto.stronachgroup.first.racehorse360.GetUserRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.User)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.User>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.UserServiceClient.prototype.getUser =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ + "/stronachgroup.first.racehorse360.UserService/GetUser",
      request,
      metadata || {},
      methodDescriptor_UserService_GetUser,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.GetUserRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.User>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.UserServicePromiseClient.prototype.getUser =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ + "/stronachgroup.first.racehorse360.UserService/GetUser",
      request,
      metadata || {},
      methodDescriptor_UserService_GetUser
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.UpdateUserPreferencesRequest,
 *   !proto.stronachgroup.first.racehorse360.UserPreferences>}
 */
const methodDescriptor_UserService_UpdateUserPreferences =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.UserService/UpdateUserPreferences",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.UpdateUserPreferencesRequest,
    stronachgroup_first_racehorse360_messages_pb.UserPreferences,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.UpdateUserPreferencesRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.UserPreferences.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.UpdateUserPreferencesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.UserPreferences)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.UserPreferences>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.UserServiceClient.prototype.updateUserPreferences =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.UserService/UpdateUserPreferences",
      request,
      metadata || {},
      methodDescriptor_UserService_UpdateUserPreferences,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.UpdateUserPreferencesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.UserPreferences>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.UserServicePromiseClient.prototype.updateUserPreferences =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.UserService/UpdateUserPreferences",
      request,
      metadata || {},
      methodDescriptor_UserService_UpdateUserPreferences
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.EditUserRequest,
 *   !proto.stronachgroup.first.racehorse360.User>}
 */
const methodDescriptor_UserService_EditUser = new grpc.web.MethodDescriptor(
  "/stronachgroup.first.racehorse360.UserService/EditUser",
  grpc.web.MethodType.UNARY,
  stronachgroup_first_racehorse360_messages_pb.EditUserRequest,
  stronachgroup_first_racehorse360_messages_pb.User,
  /**
   * @param {!proto.stronachgroup.first.racehorse360.EditUserRequest} request
   * @return {!Uint8Array}
   */
  function (request) {
    return request.constructor.encode(request).finish();
  },
  stronachgroup_first_racehorse360_messages_pb.User.decode
);

/**
 * @param {!proto.stronachgroup.first.racehorse360.EditUserRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.User)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.User>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.UserServiceClient.prototype.editUser =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ + "/stronachgroup.first.racehorse360.UserService/EditUser",
      request,
      metadata || {},
      methodDescriptor_UserService_EditUser,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.EditUserRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.User>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.UserServicePromiseClient.prototype.editUser =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ + "/stronachgroup.first.racehorse360.UserService/EditUser",
      request,
      metadata || {},
      methodDescriptor_UserService_EditUser
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.DeleteUserRequest,
 *   !proto.stronachgroup.first.racehorse360.EmptyResponse>}
 */
const methodDescriptor_UserService_DeleteUser = new grpc.web.MethodDescriptor(
  "/stronachgroup.first.racehorse360.UserService/DeleteUser",
  grpc.web.MethodType.UNARY,
  stronachgroup_first_racehorse360_messages_pb.DeleteUserRequest,
  stronachgroup_first_racehorse360_messages_pb.EmptyResponse,
  /**
   * @param {!proto.stronachgroup.first.racehorse360.DeleteUserRequest} request
   * @return {!Uint8Array}
   */
  function (request) {
    return request.constructor.encode(request).finish();
  },
  stronachgroup_first_racehorse360_messages_pb.EmptyResponse.decode
);

/**
 * @param {!proto.stronachgroup.first.racehorse360.DeleteUserRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.EmptyResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.EmptyResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.UserServiceClient.prototype.deleteUser =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.UserService/DeleteUser",
      request,
      metadata || {},
      methodDescriptor_UserService_DeleteUser,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.DeleteUserRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.EmptyResponse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.UserServicePromiseClient.prototype.deleteUser =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.UserService/DeleteUser",
      request,
      metadata || {},
      methodDescriptor_UserService_DeleteUser
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.ListUserRequest,
 *   !proto.stronachgroup.first.racehorse360.ListUserResponse>}
 */
const methodDescriptor_UserService_ListUsers = new grpc.web.MethodDescriptor(
  "/stronachgroup.first.racehorse360.UserService/ListUsers",
  grpc.web.MethodType.UNARY,
  stronachgroup_first_racehorse360_messages_pb.ListUserRequest,
  stronachgroup_first_racehorse360_messages_pb.ListUserResponse,
  /**
   * @param {!proto.stronachgroup.first.racehorse360.ListUserRequest} request
   * @return {!Uint8Array}
   */
  function (request) {
    return request.constructor.encode(request).finish();
  },
  stronachgroup_first_racehorse360_messages_pb.ListUserResponse.decode
);

/**
 * @param {!proto.stronachgroup.first.racehorse360.ListUserRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.ListUserResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.ListUserResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.UserServiceClient.prototype.listUsers =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.UserService/ListUsers",
      request,
      metadata || {},
      methodDescriptor_UserService_ListUsers,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.ListUserRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.ListUserResponse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.UserServicePromiseClient.prototype.listUsers =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.UserService/ListUsers",
      request,
      metadata || {},
      methodDescriptor_UserService_ListUsers
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.ListUserRolesRequest,
 *   !proto.stronachgroup.first.racehorse360.ListUserRolesResponse>}
 */
const methodDescriptor_UserService_ListUserRoles =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.UserService/ListUserRoles",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.ListUserRolesRequest,
    stronachgroup_first_racehorse360_messages_pb.ListUserRolesResponse,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.ListUserRolesRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.ListUserRolesResponse.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.ListUserRolesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.ListUserRolesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.ListUserRolesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.UserServiceClient.prototype.listUserRoles =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.UserService/ListUserRoles",
      request,
      metadata || {},
      methodDescriptor_UserService_ListUserRoles,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.ListUserRolesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.ListUserRolesResponse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.UserServicePromiseClient.prototype.listUserRoles =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.UserService/ListUserRoles",
      request,
      metadata || {},
      methodDescriptor_UserService_ListUserRoles
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.GetUserRoleRequestRequest,
 *   !proto.stronachgroup.first.racehorse360.UserRoleRequest>}
 */
const methodDescriptor_UserService_GetUserRoleRequest =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.UserService/GetUserRoleRequest",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.GetUserRoleRequestRequest,
    stronachgroup_first_racehorse360_messages_pb.UserRoleRequest,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.GetUserRoleRequestRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.UserRoleRequest.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.GetUserRoleRequestRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.UserRoleRequest)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.UserRoleRequest>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.UserServiceClient.prototype.getUserRoleRequest =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.UserService/GetUserRoleRequest",
      request,
      metadata || {},
      methodDescriptor_UserService_GetUserRoleRequest,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.GetUserRoleRequestRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.UserRoleRequest>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.UserServicePromiseClient.prototype.getUserRoleRequest =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.UserService/GetUserRoleRequest",
      request,
      metadata || {},
      methodDescriptor_UserService_GetUserRoleRequest
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.CreateUserRoleRequestRequest,
 *   !proto.stronachgroup.first.racehorse360.UserRoleRequest>}
 */
const methodDescriptor_UserService_CreateUserRoleRequest =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.UserService/CreateUserRoleRequest",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.CreateUserRoleRequestRequest,
    stronachgroup_first_racehorse360_messages_pb.UserRoleRequest,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.CreateUserRoleRequestRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.UserRoleRequest.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.CreateUserRoleRequestRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.UserRoleRequest)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.UserRoleRequest>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.UserServiceClient.prototype.createUserRoleRequest =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.UserService/CreateUserRoleRequest",
      request,
      metadata || {},
      methodDescriptor_UserService_CreateUserRoleRequest,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.CreateUserRoleRequestRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.UserRoleRequest>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.UserServicePromiseClient.prototype.createUserRoleRequest =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.UserService/CreateUserRoleRequest",
      request,
      metadata || {},
      methodDescriptor_UserService_CreateUserRoleRequest
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.ListUserRoleRequestsRequest,
 *   !proto.stronachgroup.first.racehorse360.ListUserRoleRequestsResponse>}
 */
const methodDescriptor_UserService_ListUserRoleRequests =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.UserService/ListUserRoleRequests",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.ListUserRoleRequestsRequest,
    stronachgroup_first_racehorse360_messages_pb.ListUserRoleRequestsResponse,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.ListUserRoleRequestsRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.ListUserRoleRequestsResponse.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.ListUserRoleRequestsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.ListUserRoleRequestsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.ListUserRoleRequestsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.UserServiceClient.prototype.listUserRoleRequests =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.UserService/ListUserRoleRequests",
      request,
      metadata || {},
      methodDescriptor_UserService_ListUserRoleRequests,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.ListUserRoleRequestsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.ListUserRoleRequestsResponse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.UserServicePromiseClient.prototype.listUserRoleRequests =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.UserService/ListUserRoleRequests",
      request,
      metadata || {},
      methodDescriptor_UserService_ListUserRoleRequests
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.ApproveUserRoleRequestRequest,
 *   !proto.stronachgroup.first.racehorse360.UserRoleRequest>}
 */
const methodDescriptor_UserService_ApproveUserRoleRequest =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.UserService/ApproveUserRoleRequest",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.ApproveUserRoleRequestRequest,
    stronachgroup_first_racehorse360_messages_pb.UserRoleRequest,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.ApproveUserRoleRequestRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.UserRoleRequest.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.ApproveUserRoleRequestRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.UserRoleRequest)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.UserRoleRequest>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.UserServiceClient.prototype.approveUserRoleRequest =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.UserService/ApproveUserRoleRequest",
      request,
      metadata || {},
      methodDescriptor_UserService_ApproveUserRoleRequest,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.ApproveUserRoleRequestRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.UserRoleRequest>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.UserServicePromiseClient.prototype.approveUserRoleRequest =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.UserService/ApproveUserRoleRequest",
      request,
      metadata || {},
      methodDescriptor_UserService_ApproveUserRoleRequest
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.RejectUserRoleRequestRequest,
 *   !proto.stronachgroup.first.racehorse360.UserRoleRequest>}
 */
const methodDescriptor_UserService_RejectUserRoleRequest =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.UserService/RejectUserRoleRequest",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.RejectUserRoleRequestRequest,
    stronachgroup_first_racehorse360_messages_pb.UserRoleRequest,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.RejectUserRoleRequestRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.UserRoleRequest.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.RejectUserRoleRequestRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.UserRoleRequest)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.UserRoleRequest>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.UserServiceClient.prototype.rejectUserRoleRequest =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.UserService/RejectUserRoleRequest",
      request,
      metadata || {},
      methodDescriptor_UserService_RejectUserRoleRequest,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.RejectUserRoleRequestRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.UserRoleRequest>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.UserServicePromiseClient.prototype.rejectUserRoleRequest =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.UserService/RejectUserRoleRequest",
      request,
      metadata || {},
      methodDescriptor_UserService_RejectUserRoleRequest
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.DeleteUserRoleRequestRequest,
 *   !proto.stronachgroup.first.racehorse360.EmptyResponse>}
 */
const methodDescriptor_UserService_DeleteUserRoleRequest =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.UserService/DeleteUserRoleRequest",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.DeleteUserRoleRequestRequest,
    stronachgroup_first_racehorse360_messages_pb.EmptyResponse,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.DeleteUserRoleRequestRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.EmptyResponse.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.DeleteUserRoleRequestRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.EmptyResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.EmptyResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.UserServiceClient.prototype.deleteUserRoleRequest =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.UserService/DeleteUserRoleRequest",
      request,
      metadata || {},
      methodDescriptor_UserService_DeleteUserRoleRequest,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.DeleteUserRoleRequestRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.EmptyResponse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.UserServicePromiseClient.prototype.deleteUserRoleRequest =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.UserService/DeleteUserRoleRequest",
      request,
      metadata || {},
      methodDescriptor_UserService_DeleteUserRoleRequest
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.PageLockerRequest,
 *   !proto.stronachgroup.first.racehorse360.TriggerPageLockerResponse>}
 */
const methodDescriptor_UserService_TriggerPageLocker =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.UserService/TriggerPageLocker",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.PageLockerRequest,
    stronachgroup_first_racehorse360_messages_pb.TriggerPageLockerResponse,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.PageLockerRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.TriggerPageLockerResponse.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.PageLockerRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.TriggerPageLockerResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.TriggerPageLockerResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.UserServiceClient.prototype.triggerPageLocker =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.UserService/TriggerPageLocker",
      request,
      metadata || {},
      methodDescriptor_UserService_TriggerPageLocker,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.PageLockerRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.TriggerPageLockerResponse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.UserServicePromiseClient.prototype.triggerPageLocker =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.UserService/TriggerPageLocker",
      request,
      metadata || {},
      methodDescriptor_UserService_TriggerPageLocker
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.PageLockerRequest,
 *   !proto.stronachgroup.first.racehorse360.EmptyResponse>}
 */
const methodDescriptor_UserService_ReleasePageLocker =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.UserService/ReleasePageLocker",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.PageLockerRequest,
    stronachgroup_first_racehorse360_messages_pb.EmptyResponse,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.PageLockerRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.EmptyResponse.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.PageLockerRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.EmptyResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.EmptyResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.UserServiceClient.prototype.releasePageLocker =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.UserService/ReleasePageLocker",
      request,
      metadata || {},
      methodDescriptor_UserService_ReleasePageLocker,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.PageLockerRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.EmptyResponse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.UserServicePromiseClient.prototype.releasePageLocker =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.UserService/ReleasePageLocker",
      request,
      metadata || {},
      methodDescriptor_UserService_ReleasePageLocker
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.PageLockerRequest,
 *   !proto.stronachgroup.first.racehorse360.PullPageLockerResponse>}
 */
const methodDescriptor_UserService_PullPageLocker =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.UserService/PullPageLocker",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.PageLockerRequest,
    stronachgroup_first_racehorse360_messages_pb.PullPageLockerResponse,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.PageLockerRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.PullPageLockerResponse.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.PageLockerRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.PullPageLockerResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.PullPageLockerResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.UserServiceClient.prototype.pullPageLocker =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.UserService/PullPageLocker",
      request,
      metadata || {},
      methodDescriptor_UserService_PullPageLocker,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.PageLockerRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.PullPageLockerResponse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.UserServicePromiseClient.prototype.pullPageLocker =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.UserService/PullPageLocker",
      request,
      metadata || {},
      methodDescriptor_UserService_PullPageLocker
    );
  };

module.exports = proto.stronachgroup.first.racehorse360;
